<credit-gaps-non-transfer-wizard *ngIf="!isTransfer"></credit-gaps-non-transfer-wizard>
<credit-gaps-transfer-wizard *ngIf="isTransfer"></credit-gaps-transfer-wizard>
